module.exports = __webpack_public_path__ + "images/Clipboard.8f4873f334d7b8fb417ba4449e828095.svg";